export const EMAIL_VALIDATION_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const URL_VALIDATION_REGEX = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
export const DANGEROUS_URL_PATTERN = /^(javascript|data|vbscript|file):/i;
